import { makeRequestCreator } from '@/api/common'
import store from '@/store'

const MyAPI = {
  /**
   *
   * @param {Function} successCallback - 성공 시 호출할 콜백
   * @param {Function} errorCallback - 실패 시 호출할 콜백
   */
  getUserData: (successCallback = () => {}, errorCallback = () => {}) => {
    makeRequestCreator(
      'getUserData',
      {
        method: 'get',
        url: `/user/info/${store.getters['main/shopSeq']}`
      },
      successCallback,
      errorCallback
    )
  },
  /**
   *
   * 사용자 보유 포인트 조회 api
   * @param {Function} successCallback - 성공 시 호출할 콜백
   * @param {Function} errorCallback - 실패 시 호출할 콜백
   */
  getUserBalance: (successCallback = () => {}, errorCallback = () => {}) => {
    makeRequestCreator(
      'getUserBalance',
      {
        method: 'get',
        url: `/user/balance/${store.getters['main/shopSeq']}`
      },
      successCallback,
      errorCallback
    )
  },
  getPurchaseList: (
    params,
    successCallback = () => {},
    errorCallback = () => {}
  ) => {
    makeRequestCreator(
      'getPurchaseList',
      {
        method: 'post',
        url: `v2/purchase/history/list/${store.getters['main/shopSeq']}`,
        data: params
      },
      successCallback,
      errorCallback
    )
  },
  getAlltemPurchaseProductList: (
    params,
    successCallback = () => {},
    errorCallback = () => {}
  ) => {
    makeRequestCreator(
      'getAlltemPurchaseList',
      {
        method: 'get',
        url: `v2/purchase/inpay/history?shopSeq=${
          store.getters['main/shopSeq']
        }&startDate=${params.startDate}&endDate=${params.endDate}`
      },
      successCallback,
      errorCallback
    )
  },
  /**
   * 구매 상세 목록
   *
   */
  getPurchaseDetail: (
    purchaseId,
    successCallback = () => {},
    errorCallback = () => {}
  ) => {
    makeRequestCreator(
      'getPurchaseDetail',
      {
        method: 'get',
        url: `v2/purchase/history/list/${
          store.getters['main/shopSeq']
        }/${purchaseId}`
      },
      successCallback,
      errorCallback
    )
  },
  /**
   * 쿠폰함 > 사용 가능 목록
   */
  getCouponUsableList: (
    params,
    successCallback = () => {},
    errorCallback = () => {}
  ) => {
    makeRequestCreator(
      'getCouponUsableList',
      {
        method: 'post',
        url: `v2/coupon/box/usable`,
        data: params
      },
      successCallback,
      errorCallback
    )
  },
  /**
   * 쿠폰함 > 사용 불가능 목록
   */
  getCouponUnusableList: (
    params,
    successCallback = () => {},
    errorCallback = () => {}
  ) => {
    makeRequestCreator(
      'getCouponUnusableList',
      {
        method: 'post',
        url: `v2/coupon/box/unusable`,
        data: params
      },
      successCallback,
      errorCallback
    )
  },
  /**
   * 쿠폰 상세
   */
  getCouponDetail: (
    couponId,
    successCallback = () => {},
    errorCallback = () => {}
  ) => {
    makeRequestCreator(
      'getCouponDetail',
      {
        method: 'get',
        url: `v2/coupon/info/${couponId}`
      },
      successCallback,
      errorCallback
    )
  },
  /**
   * 청약 철회 요청
   */
  reqCancelOrder: (
    orderId,
    successCallback = () => {},
    errorCallback = () => {}
  ) => {
    makeRequestCreator(
      'reqCancelOrder',
      {
        method: 'post',
        url: `/v2/withdraw/${store.getters['main/shopSeq']}`,
        data: {
          purchaseProductId: orderId
        }
      },
      successCallback,
      errorCallback
    )
  },
  /**
   * 청약철회목록
   */
  getWithdrawList: (
    params,
    successCallback = () => {},
    errorCallback = () => {}
  ) => {
    makeRequestCreator(
      'getWithdrawList',
      {
        method: 'post',
        url: `v2/withdraw/list/${store.getters['main/shopSeq']}`,
        data: params
      },
      successCallback,
      errorCallback
    )
  },
  /**
   * 청약철회상세
   */
  getWithdrawDetail: (
    orderId,
    successCallback = () => {},
    errorCallback = () => {}
  ) => {
    makeRequestCreator(
      'getWithdrawDetail',
      {
        method: 'get',
        url: `v2/withdraw/info/${orderId}`
      },
      successCallback,
      errorCallback
    )
  },
  /**
   * 쿠폰 활성화
   */
  activeCoupon: (
    couponId,
    successCallback = () => {},
    errorCallback = () => {}
  ) => {
    makeRequestCreator(
      'activeCoupon',
      {
        method: 'post',
        url: `v2/coupon/active`,
        data: {
          purchaseProductId: couponId
        }
      },
      successCallback,
      errorCallback
    )
  },
  /**
   * 현금 영수증
   */
  getReceipt: (
    purchaseId,
    successCallback = () => {},
    errorCallback = () => {}
  ) => {
    makeRequestCreator(
      'getReceipt',
      {
        method: 'get',
        url: `/payment/receipt/${purchaseId}`
      },
      successCallback,
      errorCallback
    )
  },
  /**
   * 쿠폰 삭제
   */
  deleteCoupon: (
    couponId,
    successCallback = () => {},
    errorCallback = () => {}
  ) => {
    makeRequestCreator(
      'deleteCoupon',
      {
        method: 'post',
        url: `v2/coupon/delete`,
        data: {
          purchaseProductId: couponId
        }
      },
      successCallback,
      errorCallback
    )
  },
  /**
   * 리워드 정보
   */
  getRewardInfo: (successCallback = () => {}, errorCallback = () => {}) => {
    makeRequestCreator(
      'getRewardInfo',
      {
        method: 'get',
        url: `/v2/reward/info/${store.getters['main/shopSeq']}`
      },
      successCallback,
      errorCallback
    )
  },
  /**
   * 리워드 정보
   */
  getRewardDetail: (
    rewardYearMonth,
    successCallback = () => {},
    errorCallback = () => {}
  ) => {
    makeRequestCreator(
      'getRewardDetail',
      {
        method: 'get',
        url: `/v2/reward/${store.getters['main/shopSeq']}/${rewardYearMonth}`
      },
      successCallback,
      errorCallback
    )
  },
  /**
   * 구매확정 요청
   */
  reqPurchaseConfirm: (
    purchaseProductId,
    successCallback = () => {},
    errorCallback = () => {}
  ) => {
    makeRequestCreator(
      'reqPurchaseConfirm',
      {
        method: 'post',
        url: `/v2/purchase/confirm/${store.getters['main/shopSeq']}`,
        data: {
          purchaseProductId
        }
      },
      successCallback,
      errorCallback
    )
  }
}

/*
구매상세목록 - /purchase/info/{shopSeq}/{orderId}
쿠폰함 목록 - /coupon/list/{shopSeq}
쿠폰상세 - /coupon/info/{shopSeq}/{orderProductCouponId}
청약철회 요청 - /withdraw/approve/{shopSeq}
청약철회목록  - v2/withdraw/list/{shopSeq}
청약철회상세 - v2/withdraw/info/{shopSeq}/{orderProductCouponId}
쿠폰 활성화 및 구매확정 - /coupon/active
*/
export default MyAPI
